<template>
  <div>
    <Main ref="main" :loading="loading" :tableData="tableData" />
  </div>
</template>

<script>
import Main from './main'
export default {
  components: { Main },
  props: { amzReplenishmentDetailCode: { type: String, default: '' } },
  data() {
    return { loading: false, tableData: [] }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentDetailCode) return []
      const params = {
        amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
      }
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyListScmFbaApi(params)
        .catch(() => null)
      this.tableData = res?.body?.data || []
    },
  },
}
</script>
